import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../../contexts/FeatureFlagContext';

const InventoryFeatureGate = ({ children }) => {
  const { inventory: inventoryEnabled } = useFeatureFlags();

  if (!inventoryEnabled) {
    return <Navigate to="/orders" replace />;
  }

  return children;
};

export default InventoryFeatureGate;


